<template>
  <div>
    <div class="d-flex">
      <v-btn
        color="green darken-2"
        class="mr-2 white--text"
        depressed
        @click.stop="editStreamingLicense()"
      >
        Streaming Setting
      </v-btn>
      <v-btn
        color="channelbtn"
        class="mr-2"
        depressed
        @click.stop="openAddDialog"
        dark
      >
        Add
      </v-btn>
      <v-btn
        color="warning"
        class="mr-2"
        depressed
        @click.stop="openEditDialog"
        :disabled="btnDisabled"
      >
        Edit
      </v-btn>
      <v-btn
        color="error"
        class="mr-2"
        depressed
        @click.stop="deleteConfirmDialog = true"
        :disabled="btnDisabled"
      >
        Remove
      </v-btn>
      <div class="ml-auto">
        <v-btn
          color="blue-grey darken-2"
          class="white--text"
          depressed
          @click.stop="editManager()"
          :disabled="btnDisabled"
        >
          <v-icon>mdi-account</v-icon> Manager
        </v-btn>
      </div>
    </div>
    <div class="mt-4">
      <v-card>
        <v-card-title>
          Live Events
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="lives"
          :search="search"
          class="border"
          show-select
          :hide-default-footer="false"
          :single-select="singleSelect"
          v-model="selectedLive"
        >
          <template v-slot:[`item.start_date`]="{ item }">
            <div>
              {{ $moment(item.start_date).format("YYYY-MM-DD") }}
            </div>
          </template>
          <template v-slot:[`item.link`]="{ item }">
            <div>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-3"
                    small
                    icon
                    @click="doLink('view', item.link)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-television-play
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">Viewer</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mr-3"
                    small
                    icon
                    @click="doLink('manage', item.link)"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon color="blue-grey" dark>
                      mdi-cog
                    </v-icon></v-btn
                  >
                </template>
                <span class="caption">Management</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <!-- 라이브 등록 모달 창 -->
    <v-dialog eager v-model="EventAddDialog" max-width="650">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Add Live Event</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeEventAddDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="ma-0 pb-0 mt-5">
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <!-- 타이틀 -->
                <v-text-field
                  label="Live Event Title"
                  hint="Ex) 포스트코로나 시대 전략 세미나"
                  :rules="liveTitleRules"
                  v-model="title"
                  :error-messages="errors"
                  color="channel"
                  required
                  @keyup.enter="createLive"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
              <!-- 스트리밍 영역 -->
              <v-col cols="12">
                <v-select
                  v-model="stream_license_id"
                  :items="streamingOptions"
                  label="Streaming Licenses"
                  color="live"
                  item-text="label"
                  item-value="id"
                  :rules="[v => !!v || 'Streaming license is required']"
                  item-disabled="disabled"
                >
                  <template v-slot:item="data">
                    {{ data.item.label }}
                    <div
                      v-if="
                        data.item.stream_mode == 'dynamic' &&
                          (!data.item.stream_embed_urls ||
                            !data.item.stream_rtmp_urls ||
                            !data.item.stream_rtmp_keys)
                      "
                    >
                      <span class="caption ml-4 set-box">Not yet set</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="createLive"
            >Save</v-btn
          >
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click.prevent="closeEventAddDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 라이브 수정 모달 창 -->
    <v-dialog eager v-model="EventEditDialog" max-width="600">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Edit Live Event</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeEventEditDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="ma-0 pb-0 mt-6">
          <v-form ref="form1">
            <v-row>
              <v-col cols="12">
                <!-- 타이틀 -->
                <v-text-field
                  label="Live Event Title"
                  hint="Ex) 포스트코로나 시대 전략 세미나"
                  :rules="liveTitleRules"
                  v-model="title"
                  :error-messages="errors"
                  color="channel"
                  required
                  @keyup.enter="createLive"
                  @keypress.enter.prevent
                ></v-text-field>
              </v-col>
              <!-- 스트리밍 영역 -->
              <v-col cols="12" class="pt-2 pb-3">
                <v-select
                  v-model="stream_license_id"
                  :items="streamingOptions"
                  label="Streaming Licenses"
                  color="live"
                  item-text="label"
                  item-value="id"
                  :rules="[v => !!v || 'Streaming license is required']"
                  item-disabled="disabled"
                >
                  <template v-slot:item="data">
                    {{ data.item.label }}
                    <div v-if="data.item.disabled">
                      <span class="caption ml-4 set-box">Not yet set</span>
                    </div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="channelbtn"
            class="mr-2 white--text"
            @click.prevent="updateLive"
            >Save</v-btn
          >
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click.prevent="closeEventEditDialog"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 라이브삭제확인 모달창 -->
    <v-dialog eager v-model="deleteConfirmDialog" width="500">
      <v-card>
        <div color="error" class="d-flex pa-2 align-center error">
          <v-card-title class="headline white--text">Delete</v-card-title>
          <div class="ml-auto">
            <v-btn icon @click="deleteConfirmDialog = false">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-7">
          <v-icon small>mdi-alert-circle-outline</v-icon> Are you sure you want
          to delete the Live Event?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2 text-capitalize"
            @click="deleteLive()"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="deleteConfirmDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 채널관리자생성 모달창 -->
    <v-dialog eager v-model="managerDialog" persistent max-width="500px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Live Manager Registration</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeManagerDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-5 pb-0">
          <v-container>
            <v-form ref="form2">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    prepend-icon="mdi-email"
                    :disabled="managerDisabled"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!managerDisabled"
            color="channelbtn"
            class="mr-2 white--text"
            @click="createManager()"
          >
            Save
          </v-btn>
          <v-btn
            v-if="managerDisabled"
            color="channelbtn"
            class="mr-2 white--text"
            @click="deleteManager()"
          >
            Delete
          </v-btn>
          <v-btn
            color="grey"
            class="text-capitalize"
            dark
            @click="closeManagerDialog()"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 스트리밍라이선스 모달창 -->
    <v-dialog eager v-model="licenseDialog" persistent max-width="650px">
      <v-card>
        <div class="d-flex pa-2 align-center channel">
          <v-card-title class="headline white--text"
            >Streaming Setting</v-card-title
          >
          <div class="ml-auto">
            <v-btn icon @click="closeLicenseDialog()">
              <v-icon small class="white--text">mdi-window-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="mt-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(item, i) in streamingOptions"
                    :key="i"
                  >
                    <v-expansion-panel-header
                      >{{ item.label }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div v-if="item.stream_mode == 'dynamic'">
                        <v-card-text class="ma-0 pb-0">
                          <v-form :ref="item.id">
                            <v-row>
                              <!-- vimeo, youtube 임베드 주소 입력 -->
                              <v-col cols="12" class="mt-0 pt-0">
                                <v-text-field
                                  outlined
                                  name="input-7-4"
                                  label="Embed Url"
                                  v-model="item.stream_embed_url"
                                  :rules="[embedUrlRules]"
                                  dense
                                  :disabled="streamInfoDisabled"
                                ></v-text-field>
                              </v-col>
                              <!-- vimeo, youtube 엔코딩 정보입력 -->
                              <v-col cols="12" class="mt-0 pt-0">
                                <v-text-field
                                  outlined
                                  name="input-7-4"
                                  label="Stream Url"
                                  v-model="item.stream_rtmp_url"
                                  :rules="[embedRtmpUrlRules]"
                                  dense
                                  :disabled="streamInfoDisabled"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" class="mt-0 pt-0">
                                <v-text-field
                                  outlined
                                  name="input-7-4"
                                  label="Stream Key"
                                  v-model="item.stream_rtmp_key"
                                  :rules="[embedRtmpKeyRules]"
                                  dense
                                  :disabled="streamInfoDisabled"
                                ></v-text-field>
                              </v-col>
                            </v-row>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="channelbtn"
                            class="mr-2 white--text"
                            @click.prevent="
                              updateDynamicLicense(
                                item.id,
                                item.stream_embed_url,
                                item.stream_rtmp_url,
                                item.stream_rtmp_key
                              )
                            "
                            >Update</v-btn
                          >
                        </v-card-actions>
                      </div>
                      <div
                        v-if="
                          item.stream_mode == 'static' ||
                            item.stream_mode == 'onseminar'
                        "
                      >
                        <v-card-text class="ma-0 pb-0">
                          <v-row>
                            <!-- vimeo, youtube 임베드 주소 입력 -->
                            <v-col
                              cols="12"
                              class="mt-0 pt-0"
                              v-if="item.stream_mode == 'static'"
                            >
                              <v-text-field
                                outlined
                                name="input-7-4"
                                label="Embed Url"
                                v-model="item.stream_embed_url"
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>
                            <!-- vimeo, youtube 엔코딩 정보입력 -->
                            <v-col cols="12" class="mt-0 pt-0">
                              <v-text-field
                                outlined
                                name="input-7-4"
                                label="Stream Url"
                                v-model="item.stream_rtmp_url"
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" class="mt-0 pt-0">
                              <v-text-field
                                outlined
                                name="input-7-4"
                                label="Stream Key"
                                v-model="item.stream_rtmp_key"
                                dense
                                disabled
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  createLive,
  updateLive,
  deleteLive,
  createUserRoles,
  deleteUserRoles,
  updateDynamicLicense
} from "../graphql/Mutation";
import { listLives, listLicensesByChannel } from "../graphql/Query";
import moment from "moment";

export default {
  name: "LiveEvents",

  data: () => ({
    stream_license_id: "",
    streamingOptions: [],
    stream_url: "",
    stream_rtmp_url: "",
    stream_rtmp_key: "",
    showTooltipCopy: false,
    EventAddDialog: false,
    EventEditDialog: false,
    singleSelect: true,
    deleteConfirmDialog: false,
    managerDialog: false,
    managerDisabled: false,
    licenseDialog: false,
    search: "",
    title: "",
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "E-mail must be valid";
      }
    ],
    lives: [],
    selectedLive: [],
    errors: [],
    headers: [
      {
        text: "ID",
        align: "start",
        value: "id",
        sortable: false
      },
      { text: "Title", value: "title", sortable: true },
      { text: "state", value: "state" },
      {
        text: "Date",
        value: "start_date",
        sortable: true
      },
      { text: "Live Manager", value: "managers[0].email", sortable: false },
      {
        text: "Link",
        value: "link",
        sortable: false
      }
    ],
    liveTitle: "",
    liveTitleRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 50) || "Name must be less than 50 characters"
    ],
    options: {},
    locations: [
      "Australia",
      "Barbados",
      "Chile",
      "Denmark",
      "Ecuador",
      "France"
    ],
    trip: {
      name: "",
      location: null,
      start: null,
      end: null
    },
    date: null
  }),

  mounted() {
    this.initialize();
  },
  computed: {
    btnDisabled: function() {
      return this.selectedLive.length <= 0;
    },
    streamInfoDisabled: function() {
      return this.stream_mode == "static" || this.stream_mode == "onseminar";
    },
    stream_mode: function() {
      const license_id = this.stream_license_id;
      const licenses = this.$store.state.channel.licenses;
      const streamLicenses = licenses.filter(license => {
        return license.mode == "stream" && license.id == license_id;
      });

      if (streamLicenses.length > 0) {
        return streamLicenses[0].stream_mode;
      } else {
        return "";
      }
    },
    stream_playback_url: function() {
      const license_id = this.stream_license_id;
      const licenses = this.$store.state.channel.licenses;
      const streamLicenses = licenses.filter(license => {
        return license.mode == "stream" && license.id == license_id;
      });

      if (streamLicenses.length > 0) {
        return streamLicenses[0].stream_playback_url;
      } else {
        return "";
      }
    }
  },
  methods: {
    async initialize() {
      // 라이브 목록 가져오기
      await this.getListLives();
      // 스트리밍 라이센스 가져오기
      await this.reloadStreamingLicenses();
    },
    async openAddDialog() {
      await this.reloadStreamingLicenses();
      this.selectedLive = [];
      this.$refs.form.reset();
      this.title = "";
      this.stream_license_id = "";
      this.EventAddDialog = true;
    },
    async openEditDialog() {
      // const channel_id = this.$store.state.channelId;
      await this.reloadStreamingLicenses();
      const selectedLive = this.selectedLive[0];
      console.log({ selectedLive });
      this.title = selectedLive.title;
      this.stream_license_id = selectedLive.stream_license_id;
      this.EventEditDialog = true;
    },

    closeEventAddDialog() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      console.log(this.stream_license_id, this.stream_mode);
      this.EventAddDialog = false;
    },

    closeEventEditDialog() {
      this.$refs.form1.resetValidation();
      this.$refs.form1.reset();
      this.EventEditDialog = false;
    },

    closeDeleteConfirmDialog() {
      this.deleteConfirmDialog = false;
    },

    closeManagerDialog() {
      this.$refs.form2.resetValidation();
      this.$refs.form2.reset();
      this.managerDialog = false;
    },
    closeLicenseDialog() {
      // this.$refs.form3.resetValidation();
      // this.$refs.form3.reset();
      this.licenseDialog = false;
    },
    embedUrlRules(v) {
      const youtubePattern = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
      const isYoutube = youtubePattern.test(v);

      const vimeoPattern = /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
      const isVimeo = vimeoPattern.test(v);

      if (isYoutube || isVimeo || this.stream_mode == "onseminar") {
        return true;
      } else {
        return "Url should be vaild.";
      }
    },
    embedRtmpUrlRules(v) {
      if (!v) return "Stream Url(rtmp) is need.";
      return true;
    },
    embedRtmpKeyRules(v) {
      if (!v) return "Stream Url(rtmp) is need.";
      if (!v) "Stream Key(rtmp) is need.";
      return true;
    },
    async createLive() {
      /**
       * 채널에 해당 라이브 생성하기
       */
      if (!this.$refs.form.validate()) return;
      const channel_id = this.$store.state.channelId;
      const title = this.title;
      const stream_license_id = this.stream_license_id;
      const state = "standby";
      const start_date = moment();
      const end_date = start_date;
      const who = "anyone";
      const when = "permanent";
      const where = "anywhere";
      // 입력값 체크
      // if (!stream_mode) return;

      // 통과했다면 저장
      try {
        console.log({ channel_id, title, stream_license_id });
        const { data } = await this.$apollo.mutate({
          mutation: createLive,
          variables: {
            input: {
              channel_id,
              title,
              state,
              start_date,
              end_date,
              who,
              when,
              where,
              stream_license_id
            }
          }
        });
        console.log("결과", data.createLive);
        if (data && data.createLive) {
          const item = data.createLive;
          // 라이브 아이템에 링크 추가
          // item.link = process.env.VUE_APP_BASE_URL + "/live/" + item.id;
          item.link = item.id;
          this.lives.push(item);
          this.lives.sort((a, b) => (a.title > b.title ? 1 : -1));

          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to add live event ${data.createLive.title} (${data.createLive.id})`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "error",
            message: `Fail to add live event ${title}`
          });
        }
        console.log(error);
      }

      this.closeEventAddDialog();
    },
    async reloadStreamingLicenses() {
      const channel_id = this.$store.state.channelId;
      try {
        const { data } = await this.$apollo.query({
          query: listLicensesByChannel,
          variables: {
            channel_id
          },
          fetchPolicy: "no-cache"
        });
        console.log("[reloadStreamingLicenses/listLicensesByChannel]", data);
        if (data.listLicensesByChannel.items) {
          const licenses = data.listLicensesByChannel.items;
          console.log({ licenses });

          // state.channel.licenses 변경
          let validLicenses = [];
          licenses.forEach(item => {
            const s = this.$moment(item.s).valueOf();
            const e = this.$moment(item.e).valueOf();
            const n = this.$moment().valueOf();
            if (s <= n && n <= e) {
              console.log({ s, e, n, item });
              validLicenses.push(item);
            }
          });
          const channel = this.$store.state.channel;
          channel.licenses = validLicenses;
          this.$store.commit("SET_CHANNEL", channel);
          // 스트리밍 옵션 추출
          const streamLicenses = validLicenses.filter(
            license => license.mode == "stream"
          );
          console.log({ streamLicenses });
          this.streamingOptions = [];
          streamLicenses.forEach(streamLic => {
            const stream_mode = streamLic.stream_mode;
            const stream_rtmp_urls = Array.isArray(streamLic.stream_rtmp_urls)
              ? streamLic.stream_rtmp_urls
              : [];
            const stream_rtmp_keys = Array.isArray(streamLic.stream_rtmp_keys)
              ? streamLic.stream_rtmp_keys
              : [];
            const stream_embed_urls = Array.isArray(streamLic.stream_embed_urls)
              ? streamLic.stream_embed_urls
              : [];

            const disabled =
              stream_mode == "dynamic" &&
              (stream_embed_urls.length < 1 ||
                stream_rtmp_urls.length < 1 ||
                stream_rtmp_keys.length < 1);

            const obj = {
              label: `[${streamLic.stream_mode}] ${streamLic.id}`,
              id: streamLic.id,
              stream_mode,
              stream_rtmp_key: stream_rtmp_keys[0],
              stream_rtmp_url: stream_rtmp_urls[0],
              stream_embed_url: stream_embed_urls[0],
              disabled
            };
            this.streamingOptions.push(obj);
            this.streamingOptions.sort((a, b) => {
              if (a.label > b.label) {
                return 1;
              }
              if (a.label < b.label) {
                return -1;
              }
              return 0;
            });
          });
        }
      } catch (e) {
        console.log(
          "[LiveList/listLicensesByChannel] listLicensesByChannel failed",
          e
        );
      }
    },
    async updateLive() {
      /**
       * 채널에 해당 라이브 생성하기
       */
      if (!this.$refs.form1.validate()) return;
      const id = this.selectedLive[0].id;
      const channel_id = this.$store.state.channelId;
      const title = this.title;
      const stream_license_id = this.stream_license_id;

      try {
        console.log({ channel_id, title, stream_license_id });
        const { data } = await this.$apollo.mutate({
          mutation: updateLive,
          variables: {
            input: {
              channel_id,
              id,
              title,
              stream_license_id
            }
          }
        });
        console.log("결과", data.updateLive);
        if (data && data.updateLive) {
          const item = data.updateLive;
          item.link = item.id;
          // 라이브 아이템에 링크 추가
          // item.link = process.env.VUE_APP_BASE_URL + "/live/" + item.id;

          this.lives.forEach(live => {
            if (live.id == item.id) {
              live.title = item.title;
              live.stream_license_id = item.stream_license_id;
            }
          });

          this.selectedLive = [];

          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to update live event ${data.updateLive.title} (${data.updateLive.id})`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "error",
            message: `Fail to update live event ${title}`
          });
        }
        console.log(error);
      }

      this.closeEventEditDialog();
    },
    async deleteLive() {
      /**
       * 채널에 해당 라이브 삭제하기
       */
      const channel_id = this.$store.state.channelId;
      const selectedLive = this.selectedLive[0];
      const id = selectedLive.id;
      const title = selectedLive.title;

      if (selectedLive.managers.length > 0) {
        this.$notify({
          type: "warning",
          title: "Live Events",
          text:
            "This Live has manager. Please retry after deleting the manager",
          duration: 6000,
          closeOnClick: true
        });
        this.closeDeleteConfirmDialog();
        return;
      }

      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteLive,
          variables: {
            input: {
              channel_id,
              id
            }
          }
        });
        if (data && data.deleteLive) {
          this.lives = this.lives.filter(item => {
            return item.id != id;
          });
          this.lives.sort((a, b) => (a.title > b.title ? 1 : -1));
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to remove live event ${data.deleteLive.title} (${data.deleteLive.id})`
          });
          this.selectedLive = [];
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "error",
            message: `Fail to remove live event ${title} (${id})`
          });
        }
      }
      this.closeDeleteConfirmDialog();
    },
    async getListLives() {
      /**
       * 채널에 해당하는 그룹목록 가져오기
       */
      const channel_id = this.$store.state.channelId;
      const limit = undefined;
      const nextToken = undefined;

      try {
        const { data } = await this.$apollo.query({
          query: listLives,
          variables: {
            channel_id,
            limit,
            nextToken
          },
          fetchPolicy: "no-cache"
        });
        console.log("[LiveList]", data);
        if (data.listLives.items) {
          this.lives = data.listLives.items;
          // 라이브 아이템에 링크 추가
          this.lives.forEach(item => {
            // item.link = process.env.VUE_APP_BASE_URL + "/live/" + item.id;
            item.link = item.id;
          });
          // 정렬
          this.lives.sort((a, b) =>
            this.$moment(a.start_date).valueOf() <
            this.$moment(b.start_date).valueOf()
              ? 1
              : -1
          );
        }
      } catch (e) {
        console.log("[LiveList] listLives failed", e);
      }
    },
    async createManager() {
      if (!this.$refs.form2.validate()) return;
      const channel_id = this.$store.state.channelId;
      const email = this.email;
      const live_id = this.selectedLive[0].id;
      const role = "lm";

      const input = [
        {
          channel_id,
          live_id,
          role,
          email
        }
      ];

      try {
        const { data } = await this.$apollo.mutate({
          mutation: createUserRoles,
          variables: {
            input
          }
        });

        if (data && data.createUserRoles) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to add manager ${email} (${live_id})`
          });
          console.log(this.lives);
          const item = this.lives.find(obj => obj.id == live_id);
          const obj = { email };
          item.managers.push(obj);
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch("logger", {
          menu: "Live Events",
          level: "error",
          message: `Failed to add manager ${email} (${live_id})`
        });
      }
      this.closeManagerDialog();
    },
    async deleteManager() {
      const channel_id = this.$store.state.channelId;
      const email = this.email;
      const live_id = this.selectedLive[0].id;
      const role = "lm";

      const input = [
        {
          channel_id,
          live_id,
          role,
          email
        }
      ];
      try {
        const { data } = await this.$apollo.mutate({
          mutation: deleteUserRoles,
          variables: { input }
        });
        // console.log(data, error);
        if (data && data.deleteUserRoles == "done") {
          const item = this.lives.find(obj => obj.id == live_id);
          item.managers = [];
          this.managerDisabled = false;
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to remove manager ${email} (${live_id})`
          });
        }
      } catch (error) {
        this.$store.dispatch("logger", {
          menu: "Live Events",
          level: "error",
          message: `Failed to remove manager ${email} (${live_id})`
        });
      }

      this.closeManagerDialog();
    },
    editManager() {
      const item = this.selectedLive[0];

      console.log(item.managers.length);
      if (item.managers.length > 0) {
        this.managerDisabled = true;
        if (item.managers[0].email) this.email = item.managers[0].email;
      } else {
        this.managerDisabled = false;
      }

      this.managerDialog = true;
    },
    async editStreamingLicense() {
      this.licenseDialog = true;
      await this.reloadStreamingLicenses();
    },
    async updateDynamicLicense(
      id,
      stream_embed_url,
      stream_rtmp_url,
      stream_rtmp_key
    ) {
      if (!this.$refs[id][0].validate()) return;
      console.log(this.$refs[id][0].validate());
      // 입력값이 없는 경우 진행안함
      // if (this.embedUrlRules(stream_embed_url) !== true) return;
      // if (this.embedRtmpUrlRules(stream_rtmp_url) !== true) return;
      // if (this.embedRtmpKeyRules(stream_rtmp_key) !== true) return;

      const channel_id = this.$store.state.channelId;
      console.log({
        id,
        stream_embed_url,
        stream_rtmp_url,
        stream_rtmp_key,
        channel_id
      });
      try {
        const { data } = await this.$apollo.mutate({
          mutation: updateDynamicLicense,
          variables: {
            input: {
              id,
              channel_id,
              stream_embed_url,
              stream_rtmp_url,
              stream_rtmp_key
            }
          }
        });
        console.log("결과", data.updateDynamicLicense);
        if (data && data.updateDynamicLicense) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "success",
            message: `Success to update dynamic license's infomation ${data.updateDynamicLicense.id}`
          });
        }
      } catch (error) {
        if (error) {
          this.$store.dispatch("logger", {
            menu: "Live Events",
            level: "error",
            message: `Fail to update dynamic license's infomation ${id}`
          });
        }
        console.log(error);
      }
    },
    doLink(mode, id) {
      if (mode == "view") {
        const url = process.env.VUE_APP_BASE_URL + "/live/" + id;
        window.open(url, "_blank");
      }
      if (mode == "manage") {
        const url = process.env.VUE_APP_BASE_URL + "/console/live/" + id;
        window.open(url, "_blank");
      }
      if (mode == "copy") {
        const url = process.env.VUE_APP_BASE_URL + "/console/live/" + id;
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = url;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        console.log("a");
        this.$notify({
          type: "success",
          title: "Live Management link is copied!!",
          text: "Paste(Ctrl+v) in new window and goto live manager page",
          duration: 6000,
          closeOnClick: true
        });
        console.log("b");
      }
    }
  }
};
</script>
<style scoped>
.set-box {
  border: 1px #e2e2e2 solid;
  border-radius: 4px;
  padding: 1px 5px;
}
</style>
